export const pagesGetters = {
  pagesFormStatus: (state) => state.pagesFormStatus,
  pagesIsEdit: state => state.pagesIsEdit,
  pagesSelectedForEdit: state => state.pagesSelectedForEdit,
  pagePublishRequest : state => state.pagePublishRequest,
};